<app-header></app-header>
<div id="sectionsContainer">
    <router-outlet (activate)="onActivate()"></router-outlet>
</div>
<app-footer></app-footer>
